import {
  GlobalApiErrorTrackingService,
  provideAnalyticsConfigurationUsingClass,
  provideSelfServeAnalyticsService,
} from '@rci/self-serve-fido/core/analytics';
import { ChangeCallerIdAnalyticsConfigurationService } from './analytics/change-caller-id-analytics-configuration.service';
import { ChangeCallerIdConfigService, changeCallerIdRoutes } from '@rogers/self-serve-wireless/change-caller-id';
import { ChangeCallerIdAppConfigService } from './change-caller-id-app.config.service';
import { BreadcrumbsService } from '@rci/self-serve-fido/core/breadcrumbs/breadcrumbs.service';
import { AccountDetailFacadeService } from '@rogers/self-serve-common/account';
import { getWirelessDeeplinkGuard } from '@rci/self-serve-fido/guard/routing.guards';
import { GroupIdOrSubscriberDeeplinkGuard } from '@rci/self-serve-fido/guard/group-id-or-subscriber-deeplink.guard';

export const changeCallerIdAppRoutes = [
  {
    path: 'change-caller-id',
    children: [...changeCallerIdRoutes],
    canActivate: [...getWirelessDeeplinkGuard('change-caller-id'), GroupIdOrSubscriberDeeplinkGuard],
    providers: [
      provideAnalyticsConfigurationUsingClass(ChangeCallerIdAnalyticsConfigurationService),
      provideSelfServeAnalyticsService(),
      {
        provide: ChangeCallerIdConfigService,
        useClass: ChangeCallerIdAppConfigService,
        deps: [BreadcrumbsService, AccountDetailFacadeService, GlobalApiErrorTrackingService],
      },
    ],
  },
];
